import React from 'react'
import R from 'ramda'

class ImageWithLoaderAndDefaultForPopup extends React.Component {
  constructor(props){
    super(props)
    this.state = {imgStatus: 'LOADING'}
    this.onLoad = this.onLoad.bind(this)
    this.onError = this.onError.bind(this)
  }
  shouldComponentUpdate(nextProps, nextState){
    return !R.equals(this.props, nextProps) || !R.equals(this.state, nextState)
  }
  onLoad(){
    this.setState({imgStatus: "LOADED"})
  }
  onError(){
    this.setState({imgStatus: "ERROR"})
  }
  currentUrl(){
    if(this.state.imgStatus === "ERROR"|| !this.props.imgSrc) {
      return this.props.defaultSrc
    }
    else return this.props.imgSrc
  }

  render(){

    const currentUrl = this.currentUrl()
    if(this.state.imgStatus === "ERROR" || this.state.imgStatus == "LOADED"){
      return <img className="image-loader-popup-done" src={currentUrl}/>
    }
    return <img className="image-loader-popup" src={currentUrl} onLoad={this.onLoad} onError={this.onError}/>

  }
}

ImageWithLoaderAndDefaultForPopup.propTypes = {
  imgSrc: React.PropTypes.string,
  defaultSrc: React.PropTypes.string.isRequired,
}

export default ImageWithLoaderAndDefaultForPopup



/** WEBPACK FOOTER **
 ** ./app/components/ImageWithLoaderAndDefaultForPopup.jsx
 **/